export default {
  'All Videos': '',
  Training: 'true',
  Trace: 'false',
};
